import { useState } from "react";
import { Link } from "react-router-dom";
import useSeo from "../../hooks/useSeo";
import { faqs } from "../../mocks/faq";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  useSeo({
    title: "常见问题 - 追更同人、作品收录与使用指南 | 忍界同人志",
    description:
      "忍界同人志常见问题：作品库如何更新、如何查找某类同人、是否支持投稿、侵权内容如何反馈等，一站式解答你的追更疑问。",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  });

  return (
    <div className="pt-16 md:pt-[72px]">
      <section className="relative overflow-hidden border-b border-background-300/60 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-foreground-400">
            <Link to="/" className="transition-colors hover:text-primary-300">首页</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-600">常见问题</span>
          </nav>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">常见问题</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-400">
            关于作品库更新、查找同人、收录原则与内容反馈的常见疑问，这里为你一一解答。没有找到答案？欢迎通过关于我们页面联系我们。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 md:px-6 py-12 md:py-16">
        <div className="divide-y divide-background-300/60 overflow-hidden rounded-lg border border-background-300/60 bg-background-100">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                  aria-expanded={open}
                >
                  <span className="flex items-center gap-3">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-500"}`}>
                      {i + 1}
                    </span>
                    <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">{f.q}</span>
                  </span>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300/70 text-foreground-400 transition-transform ${open ? "rotate-45 text-primary-300" : ""}`}>
                    <i className="ri-add-line" />
                  </span>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${open ? "max-h-96 pb-5" : "max-h-0"}`}>
                  <p className="px-5 text-sm leading-relaxed text-foreground-400 md:px-16">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-8 rounded-lg border border-primary-500/30 bg-primary-500/10 p-6 text-center">
          <h2 className="font-heading text-lg font-semibold text-foreground-950">还有问题没有解决？</h2>
          <p className="mt-2 text-sm text-foreground-400">欢迎通过邮箱联系我们，我们会认真回复每一封来信。</p>
          <a
            href="mailto:hello@nijitongren.example.com"
            className="mt-4 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-mail-line" />
            联系我们
          </a>
        </div>
      </section>
    </div>
  );
}